import styled from 'styled-components/macro';

export const FilterBar = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-width: 0;
  gap: ${({ theme }) => theme.padding}px;
`;

export const FilterDropdowns = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  position: relative;
  z-index: 2;

  > div {
    max-width: none;
    flex: 1 1 16rem;
    min-width: 12rem;
  }
`;

export const FilterSecondRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.padding}px;
  width: 100%;
  min-width: 0;
`;

export const AdminPostsFilter = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 40px;
  padding: 0 18px;
  background-color: ${({ theme }) => theme.backgrounds.white};
  box-shadow: ${({ theme }) => theme.shadows.lighter};
  border-radius: ${({ theme }) => theme.borderRadius.md * 0.9}px;
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  user-select: none;

  label {
    margin-bottom: 0;
    font-size: 1.3rem;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: #21679a;
    white-space: nowrap;
  }
`;

export const ParticipantDropdownContainer = styled.div<{ $disabled?: boolean; $open?: boolean }>`
  position: relative;
  flex: 1;
  min-width: 16rem;
  max-width: 36rem;
  height: 40px;
  background-color: ${({ theme }) => theme.backgrounds.white};
  box-shadow: ${({ theme }) => theme.shadows.lighter};
  border-radius: ${({ theme }) => theme.borderRadius.md * 0.9}px;
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  overflow: visible;
  z-index: ${({ $open }) => ($open ? 20 : 1)};
`;

export const ParticipantDropdownHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 18px;
  cursor: pointer;
`;

export const ParticipantDropdownLabel = styled.span<{ $disabled?: boolean }>`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1.3rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ $disabled, theme }) => ($disabled ? theme.primary.lightGrey : '#21679a')};
`;

export const ParticipantDropdownSearch = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 1.3rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: #21679a;

  ::placeholder {
    color: ${({ theme }) => theme.primary.lightGrey};
    font-weight: ${({ theme }) => theme.fontWeights.regular};
  }
`;

export const ParticipantDropdownArrow = styled.img`
  margin-left: auto;
  flex-shrink: 0;
`;

export const ParticipantDropdownOptions = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 30;
  min-width: 100%;
  width: max-content;
  max-width: min(42rem, 90vw);
  max-height: 28rem;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.backgrounds.white};
  box-shadow: ${({ theme }) => theme.shadows.lighter};
  border-radius: ${({ theme }) => theme.borderRadius.md * 0.9}px;
  user-select: none;
`;

export const ParticipantDropdownOption = styled.div<{ $bold?: boolean }>`
  padding: 0 18px 0 ${({ $bold }) => ($bold ? '18px' : '28px')};
  line-height: 3rem;
  white-space: nowrap;
  font-size: ${({ $bold }) => ($bold ? '1.3rem' : '1.1rem')};
  font-weight: ${({ theme, $bold }) =>
    $bold ? theme.fontWeights.bold : theme.fontWeights.regular};
  color: ${({ theme }) => theme.primary.dark};
  opacity: 0.48;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

export const ParticipantDropdownEmpty = styled.div`
  padding: 0 18px;
  line-height: 3rem;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.primary.lightGrey};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  color: ${({ theme }) => theme.primary.dark};
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-align: center;
`;

export const PostList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.padding * 1.5}px;
`;

export const PostCard = styled.div`
  position: relative;
  background: ${({ theme }) => theme.primary.white};
  border: 1px solid ${({ theme }) => theme.borders.xlight};
  border-radius: ${({ theme }) => theme.borderRadius.lg}px;
  box-shadow: ${({ theme }) => theme.shadows.lighter};
  padding: ${({ theme }) => theme.padding * 1.5}px ${({ theme }) => theme.padding * 2}px;
`;

export const PostHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.padding}px;
  padding-right: 4rem;
`;

export const Avatar = styled.img`
  flex: 0 0 auto;
  height: 4.4rem;
  width: 4.4rem;
  border-radius: 50%;
  margin-right: ${({ theme }) => theme.padding}px;
  object-fit: cover;
  background: ${({ theme }) => theme.backgrounds.lightGrey};
`;

export const AuthorBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AuthorName = styled.span`
  color: ${({ theme }) => theme.primary.dark};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: 1.5rem;
`;

export const PostMeta = styled.span`
  color: ${({ theme }) => theme.primary.lightGrey};
  font-size: 1.2rem;
  margin-top: 2px;
`;

export const Badge = styled.span`
  display: inline-block;
  align-self: flex-start;
  background: ${({ theme }) => theme.primary.paleBlue};
  color: ${({ theme }) => theme.primary.dark};
  border-radius: ${({ theme }) => theme.borderRadius.sm}px;
  padding: 0.3rem 1rem;
  margin-bottom: ${({ theme }) => theme.padding}px;
  font-size: 1.1rem;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;

export const PostTitle = styled.h4`
  margin: 0 0 0.4rem;
  color: ${({ theme }) => theme.primary.dark};
  font-size: 1.6rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const PostMessage = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.primary.dark};
  font-size: 1.4rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const PostImage = styled.img`
  display: block;
  margin-top: ${({ theme }) => theme.padding}px;
  max-width: 100%;
  max-height: 320px;
  border-radius: ${({ theme }) => theme.borderRadius.md}px;
  object-fit: cover;
`;

export const MediaWrapper = styled.div`
  margin-top: ${({ theme }) => theme.padding}px;
  border-radius: ${({ theme }) => theme.borderRadius.md}px;
  overflow: hidden;
`;

export const CompanyTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: ${({ theme }) => theme.padding}px;
`;

export const CompanyTag = styled.span`
  background: ${({ theme }) => theme.backgrounds.lightBlue};
  color: ${({ theme }) => theme.primary.dark};
  border-radius: ${({ theme }) => theme.borderRadius.sm}px;
  padding: 0.2rem 0.8rem;
  font-size: 1.1rem;
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.padding * 1.5}px;
  right: ${({ theme }) => theme.padding * 1.5}px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.4rem;
  width: 3.4rem;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  transition: all 150ms;

  :hover {
    background: ${({ theme }) => theme.backgrounds.lightGrey};
    transform: scale(1.05);
  }
`;

export const DeleteIcon = styled.img`
  height: 1.8rem;
  width: 1.8rem;
`;

export const PaginationWrapper = styled.div`
  margin-top: ${({ theme }) => theme.padding * 2}px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.padding}px;
`;
